//importer les feuille de styles
import './assets/styles/core.scss';


//Importation des components
import "./components/index";

import "jquery";
import "bootstrap";